<template>
  <div
    data-qa="trigger-bidSubmit">
    <sFormItem
      prop="valueMutable"
      :rules="rules.valueMutable">
      <sCheckbox
        data-qa="isNewBidSubmitting__checkbox"
        :disabled="disabled"
        :value="valueMutable.IsNewBidSubmitting"
        @change="val => changeProp('IsNewBidSubmitting', val)">
        {{ $t('Automation.NewBid') }}
      </sCheckbox>
      <sCheckbox
        class="mt-2"
        data-qa="isReBidSubmitting__checkbox"
        :disabled="disabled"
        :value="valueMutable.IsReBidSubmitting"
        @change="val => changeProp('IsReBidSubmitting', val)">
        {{ $t('Automation.ResubmissionBid') }}
      </sCheckbox>
      <sCheckbox
        class="mt-2"
        data-qa="isPriceConfirmation__checkbox"
        :disabled="disabled"
        :value="valueMutable.IsPriceConfirmation"
        @change="val => changeProp('IsPriceConfirmation', val)">
        {{ $t('Automation.ConfirmPriceRequest') }}
      </sCheckbox>
    </sFormItem>
  </div>
</template>
<script>
/**
 * Подача пропозиції
*/
export default {
  name: 'bidSubmit',
  data() {
    return {
      rules: {
        valueMutable: {
          type: 'object',
          trigger: 'change',
        },
      }
    }
  },
  methods: {
    changeProp(prop, value) {
      const result = this.$_.cloneDeep(this.valueMutable)
      result[prop] = value
      this.valueMutable = result
    }
  },
  computed: {
    valueMutable: {
      get() {
        const defaultModel = {
          IsNewBidSubmitting: false,
          IsReBidSubmitting: false,
          IsPriceConfirmation: false,
        }
        if (!this.value) {
          return defaultModel
        }
        try {
          return JSON.parse(this.value) || defaultModel
        } catch {
          return defaultModel
        }
      },
      set(newValue) {
        this.$emit('update:value', JSON.stringify(newValue))
      }
    },
  },
  props: {
    value: {
      type: String,
    },
    disabled: {
      type: Boolean
    }
  },
}
</script>
